import { QueryClient } from '@tanstack/react-query';

/**
 * Single shared React Query client.
 *
 * Lives in its own module (not in main.tsx) so non-component code — notably the
 * auth store — can clear the cache at the auth-identity boundary (login/logout)
 * without a circular dependency. This prevents one user's cached data from
 * bleeding into the next user's session in the same browser tab.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,
      retry: 1,
    },
  },
});
